import * as $ from 'jquery';
import { Component, OnInit, Inject, ViewChild, AfterViewInit, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { serviceUrl } from '../common/serviceconstants';
import { Router, ActivatedRoute } from '@angular/router';
import { GenericHttpClient } from '../Services/Basicauthentication';
import { UtilityServices } from '../UtilityServices';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { ThemePalette } from '@angular/material/core';
import { CurrencyPipe } from '@angular/common'
import { EmitterService } from '../emitterservice';
import { registerables } from 'node_modules/chart.js'
import { Chart } from "chart.js";
import { ChartComponent } from "ng-apexcharts";
import { IDropdownSettings, } from 'ng-multiselect-dropdown';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss']
})
export class ResourcesComponent {
  gender: string = '';
  communitygoal: any = [];

  dropdownList = [];
  dropdownSettings:IDropdownSettings={};
  dropDownForm:FormGroup;
  selectedItems=[];

  constructor(private fb: FormBuilder,private http: HttpClient, private router: Router, private httpClient: GenericHttpClient,
    private utility: UtilityServices, private cp: CurrencyPipe) {

    this.getCommunitygoals();
    this.usersTemp = this.users;
  }


usersTemp = [];
  users: any[] = [
    { name: 'Nonprofits Investments Summary Report', communitygoal:'Goals 1, 2, 3, 4, 5, 6, 7, 8, 9, 10', publisheddate:'February 2022',links: 'https://nonprofits.coj.net/Nonprofit-Investments-Summary-Report' },
    { name: 'Mayor Curry Investments in Critical Quality of Life Issues Presentation',communitygoal:'Goals 3, 6, 8, 9',  publisheddate:'September 2022',links: 'https://nonprofits.coj.net/Mayor-Curry-Investments-in-CQLI' },
    { name: 'COJ Critical Quality of Life Issues Investments Report', communitygoal:'Goals 3, 6, 8, 9',  publisheddate:'October 2022',links: 'https://nonprofits.coj.net/COJ-CQLI-Investments-Report-October-2022' },
    { name: 'COJ Critical Quality of Life Issues Investments Housing Report', communitygoal:'Goals 3, 8',  publisheddate:'October 2022',links: 'https://nonprofits.coj.net/COJ-CQLI-Investments-Housing-Report' },
    { name: 'COJ Critical Quality of Life Issues Investments Homelessness Report',communitygoal:'Goals 3, 6, 8, 9',  publisheddate:'October 2022',links: 'https://nonprofits.coj.net/COJ-CQLI-Investments-Homelessness-Report' },
    { name: 'COJ Critical Quality of Life Issues Investments Healthcare Report', communitygoal:'Goals 8, 9',  publisheddate:'October 2022',links: 'https://nonprofits.coj.net/COJ-CQLI-Investments-Healthcare-Report' }
  ];

  ngOnInit(): void {
    // this.dropdownList = [
    //   { communityGoalsID: 1, communityGoals: '1.Quality Places' },
    //   { communityGoalsID: 2, communityGoals: '2.Resilient Infrastructure and Natural Resources' },
    //   { communityGoalsID: 3, communityGoals: '3.Vibrant and Thriving Neighborhoods' },
    //   { communityGoalsID: 4, communityGoals: '4.Innovation and Economic Development' },
    //   { communityGoalsID: 5, communityGoals: '5.Equitable and Shared Prosperity' },
    //   { communityGoalsID: 6, communityGoals: '6.Economic Mobility' },
    //   { communityGoalsID: 7, communityGoals: '7.Quality Education' },
    //   { communityGoalsID: 8, communityGoals: '8.Health and Wellness' },
    //   { communityGoalsID: 9, communityGoals: '9.Food Security and Nutrition' },
    //   { communityGoalsID: 10, communityGoals: '10.Public Safety' }
    // ];
    this.dropdownSettings = {
      idField: 'communityGoalsID',
      textField: 'communityGoalsConcat',
      selectAllText: 'Select All',
      showSelectedItemsAtTop:false,
      itemsShowLimit: 1,
      maxHeight:400
    };
    this.dropDownForm = this.fb.group({
      myItems: [this.selectedItems]
  });
}



//communityGoal: any = [];
communityGoals: any = [];
communityGoalsID: any;
getCommunitygoals(): void {
  this.httpClient.get(serviceUrl + '/api/DropDown/GetCommunityGoals',
    '').toPromise<any>().then(response => {
      this.communityGoals = response;
      this.dropdownList = response;
      this.selectedItems = response;
      this.dropDownForm = this.fb.group({
        myItems: [this.selectedItems]
    });
    let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span style="color:#18436b !important;"><b>ALL </b>&nbsp;</span>   </span>    </span>'
    let dhtml = document.querySelectorAll("#CommunityFramework .dropdown-btn");
    if(dhtml.length >0){
      dhtml[0].innerHTML=html;
    }
      //console.log(response);
    });
}
onItemSelect(item: any) {
  //console.log('onItemSelect', item);
  //this.communitygoal = item.communityGoalsID;
  // this.items = undefined;
  // this.cgoalchange()
  if(this.communitygoal.length >1)
  {
  let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span style="color:#18436b !important;"><b>Multiple </b>&nbsp;</span>   </span>    </span>'
  let dhtml = document.querySelectorAll("#CommunityFramework .dropdown-btn");
  if(dhtml.length >0){
    dhtml[0].innerHTML=html;
  }
} else {
  let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span _ngcontent-dta-c288="">'+item.communityGoalsConcat +'&nbsp;</span>   </span>    </span>'
  let dhtml = document.querySelectorAll("#CommunityFramework .dropdown-btn");
  if(dhtml.length >0){
    dhtml[0].innerHTML=html;
  }
}
  this.filterUsers();
}
onItemDeSelect(item: any) {
  //sconsole.log('onItemDeSelect', item);
 // this.communitygoal = item.communityGoalsID;
  // this.items = undefined;
  // this.cgoalchange()
  if(this.communitygoal.length >1)
  {
  let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span style="color:#18436b !important;"><b>Multiple </b>&nbsp;</span>   </span>    </span>'
  let dhtml = document.querySelectorAll("#CommunityFramework .dropdown-btn");
  if(dhtml.length >0){
    dhtml[0].innerHTML=html;
  }
} else if(this.communitygoal.length == 1) {
  let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span _ngcontent-dta-c288="">'+this.communitygoal[0].communityGoalsConcat +'&nbsp;</span>   </span>    </span>'
  let dhtml = document.querySelectorAll("#CommunityFramework .dropdown-btn");
  if(dhtml.length >0){
    dhtml[0].innerHTML=html;
  }
}else  {
  let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span _ngcontent-dta-c288=""><b>ALL </b> &nbsp;</span>   </span>    </span>'
  let dhtml = document.querySelectorAll("#CommunityFramework .dropdown-btn");
  if(dhtml.length >0){
    dhtml[0].innerHTML=html;
  }

}
  if(this.communitygoal.length == 0)
  {
    this.isunseclected = true;
  }
  this.filterUsers();
}
onSelectAll(items: any) {
  //console.log('onSelectAll', items);
  this.communitygoal = items;
  let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span style="color:#18436b !important;"><b>ALL </b>&nbsp;</span>   </span>    </span>'
    let dhtml = document.querySelectorAll("#CommunityFramework .dropdown-btn");
    if(dhtml.length >0){
      dhtml[0].innerHTML=html;
    }
  // this.cgoalchange()
  this.filterUsers();
}

isunseclected : any =  false;
onUnSelectAll(items: any) {
  //console.log('onUnSelectAll fires',items);

   this.communitygoal = items;
   this.isunseclected = true;
  // this.cgoalchange()
  this.filterUsers();
}

onDropDownClose() {
//console.log('dropdown closed');
 //this.communitygoal = undefined;
 //this.getCommunitygoals();
 //this.communitygoal = undefined;
 setTimeout(() => {
  //this.filterUsers()
  let u =[];
  if(this.isunseclected && this.communitygoal.length == 0){
  this.users = this.usersTemp;
  this.dropdownList.forEach(r => {
    this.users.forEach(s => {
     let exists =  u.filter(d => d.name == s.name)
     if(exists.length == 0)
     {
      if(s.communitygoal.includes(r.communityGoalsID)){
          u.push(s);
      }
    }
    })
  })
  this.users= u;
}
  this.isunseclected = false;
 
  //window.location.reload();
  },200);
  

}
message ="";
filterUsers(){
  this.users = this.usersTemp;
  let u =[];
  // this.users.forEach(r => {
  //   this.communitygoal.forEach(s => {
  //     if(r.communitygoal.includes(s.communityGoalsID)){
  //         u.push(r);
  //     }
  //   })
  // })
  if(!this.isunseclected){
  this.communitygoal.forEach(r => {
    this.users.forEach(s => {
     let exists =  u.filter(d => d.name == s.name)
     if(exists.length == 0)
     {
      if(s.communitygoal.includes(r.communityGoalsID)){
          u.push(s);
      }
    }
    })
  })
} else {
  
  this.communitygoal.forEach(r => {
    this.users.forEach(s => {
     let exists =  u.filter(d => d.name == s.name)
     if(exists.length == 0)
     {
      if(s.communitygoal.includes(r.communityGoalsID)){
          u.push(s);
      }
    }
    })
  })
}
//this.isunseclected = false;
  this.users= u;
  if(this.users.length == 0){
    this.message = "No Reports available at this time. Please try again!";

  } else {
    this.message="";
  }
}
  
ResetResourcesPage(){

  window.location.reload();
}

OpenquickreferenceguidePDF(){
  const pdfurl = "assets/documents/QuickReferenceGuide-MyJaxCommunityConnect.pdf"
  window.open(pdfurl, '_blank');
}

OpenAbbrevitionPDF(){
  const pdfurl2 = "assets/documents/AcronymAbbreviationKey.pdf"
  window.open(pdfurl2, '_blank');
}
  
}

  
